module.exports = __webpack_public_path__ + "static/media/DiscoverSectionImages.25486eb6.webp";